"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepsNumerable = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const lodash_times_1 = tslib_1.__importDefault(require("lodash.times"));
const steps_1 = tslib_1.__importDefault(require("antd/es/steps"));
const __1 = require("..");
exports.StepsNumerable = ({ direction = 'vertical', maxSteps, currentStep, onChangeStep }) => {
    return (React.createElement(steps_1.default, { direction: direction, current: currentStep, onChange: onChangeStep }, lodash_times_1.default(maxSteps, step => (React.createElement(__1.Step, { icon: step + 1, key: step })))));
};
//# sourceMappingURL=StepsNumerable.js.map